import { axios, def, handleError } from './internal';

function AdminModerationStats(setData, days = 30) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_moderation_stats', { days })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, rows: res.data.data ?? [] });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

export { AdminModerationStats };
